import React from 'react';
import DataComponent from 'components/DataComponent';
import Chart from 'react-apexcharts'
import PageCard from 'components/PageCard';
import ExcelIcon from 'components/ExcelIcon';


type WorkoutsPerWorkoutDayProps = {
    partner : string
}

/* v2 */

class WorkoutsPerWorkoutDay extends DataComponent<WorkoutsPerWorkoutDayProps> {
  baseUrl = "workouts-per-workout-day/"

  get url() {
    return `${this.baseUrl}?partner=${this.props.partner}`
  }

  _render() {
    return (
      <PageCard title="Histogram of # workouts per workout day" subtitle="" xlurl={this.url+"&xl=1"}>
          <Chart
            options={ {
              xaxis: { categories: this.data.workouts },
              //plotOptions: { hideOverflowingLabels: false },
            } }
            series={ [

                

                      { name: "count", data: this.data.count },

                

            ] }
            type="bar"
            width="100%" height={450}
          />
      </PageCard>
    );
  }
}


export default WorkoutsPerWorkoutDay;
